import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/logo_leanpath.png'


const _hoisted_1 = { class: "centered-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "md-body-1" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "actions verify-button-area" }
const _hoisted_6 = { class: "links" }
const _hoisted_7 = {
  key: 0,
  class: "loading-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_md_input = _resolveComponent("md-input")!
  const _component_md_field = _resolveComponent("md-field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_md_snackbar = _resolveComponent("md-snackbar")!
  const _component_md_progress_spinner = _resolveComponent("md-progress-spinner")!
  const _component_md_content = _resolveComponent("md-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications),
    _createVNode(_component_md_content, { class: "md-elevation-3" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('検証コードを入力してください')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_md_field, null, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('メールアドレス')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event))
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_md_field, null, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('検証コード')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.verifyCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.verifyCode) = $event))
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, _toDisplayString(_ctx.$t('検証')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createVNode(_component_router_link, {
              class: "forgetpass",
              to: "/forgetpass"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('もう一度パスワードをリセットする')), 1)
              ], undefined, true),
              _: 1
            })
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle(_ctx.styles.toLogin)
          }, [
            _createVNode(_component_router_link, {
              class: "login",
              to: "/login"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ログイン画面へ')), 1)
              ], undefined, true),
              _: 1
            })
          ], 4)
        ]),
        _createVNode(_component_md_snackbar, {
          "md-active": _ctx.state.showSnackbar,
          "onUpdate:mdActive": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.showSnackbar) = $event)),
          "md-position": "center",
          "md-duration": 2000,
          "md-persistent": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.state.snackMessage), 1)
          ], undefined, true),
          _: 1
        }, 8, ["md-active"]),
        (_ctx.state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_md_progress_spinner, {
                "md-mode": "indeterminate",
                "md-stroke": 2
              })
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "background" }, null, -1))
  ]))
}